import React from 'react'
import Helmet from 'react-helmet'
import _sortBy from 'lodash/sortBy'
import autoBind from 'react-autobind'

import TeamMember from '../components/TeamMember'
import Header from "../components/Nav.js";
import Content from "../components/Content.js"


import './Team.css'

export default class Team extends React.Component {
   constructor(props) {
    super(props);
    this.state = {
    };
    autoBind(this);
  }
  
  render(){
    var {page,  team = [] } = this.props;
    console.log(this.props);
    team = _sortBy(team, ['date']).reverse()
    return (
      <main className='Team'>
        <Helmet>
          <title>{page[7].title}</title>
        </Helmet>
        <Header />
        <div className="heritageTitle">{page[7].title}</div>
        <div className="sectionTushek">
          <div className="container">
            <Content source={page[7].text} />
          </div>
        </div>
        <div style={{minHeight:"calc(100vh - 340px)"}} className='section'>
          <div className='containerTeam'>
            <div className="teamWrapper">{team.map((objavaSearched, i) => <TeamMember {...team[i]} key={i} />)}</div>
          </div>
        </div>
        
        
      </main>
    )
  }
}
      


// WEBPACK FOOTER //
// ./src/views/Team.js